import toast from "react-hot-toast";

class UserAPIs {
    static async list({ axiosPrivate, agency_id, status, search, role_id, internal, is_deleted = false, limit = 20, offset = 0 }) {
        try {
            const params = new URLSearchParams({
                is_deleted: String(is_deleted),
                ...(agency_id && { agency_id }),
                ...(status && { status }),
                ...(search && { search }),
                ...(role_id && { role_id }),
                ...(internal && { internal: "true" }),
                ...(limit != null && { limit }),
                ...(offset != null && { offset }),
            });
            const url = `/api/v1/agency/users/?${params.toString()}`;
            const response = await axiosPrivate.get(url);
            const list = response?.data?.data ?? response?.data ?? [];
            const count = response?.data?.count ?? list?.length ?? 0;
            return { data: Array.isArray(list) ? list : [], count };
        } catch (error) {
            const status = error?.response?.status;
            if (status !== 403 && status !== 401) {
                toast.error(error?.response?.data?.error_message || error?.message);
            }
            return { data: [], count: 0 };
        }
    }

    static async create({ axiosPrivate, payload }) {
        try {
            const url = `/api/v1/agency/users/`;
            const response = await axiosPrivate.post(url, payload);
            return response?.data?.data ?? response?.data;
        } catch (error) {
            toast.error(error?.response?.data?.error_message || error?.message);
            throw error;
        }
    }

    static async update({ axiosPrivate, id, payload }) {
        try {
            const url = `/api/v1/agency/users/${id}/`;
            const response = await axiosPrivate.patch(url, payload);
            return response?.data?.data ?? response?.data;
        } catch (error) {
            toast.error(error?.response?.data?.error_message || error?.message);
            throw error;
        }
    }

    static async retrieve({ axiosPrivate, id }) {
        try {
            const url = `/api/v1/agency/users/${id}/`;
            const response = await axiosPrivate.get(url);
            return response?.data?.data ?? response?.data;
        } catch (error) {
            toast.error(error?.response?.data?.error_message || error?.message);
        }
    }

    static async delete({ axiosPrivate, id }) {
        try {
            const url = `/api/v1/agency/users/${id}/`;
            const response = await axiosPrivate.patch(url, { is_deleted: true });
            return response?.data?.data ?? response?.data;
        } catch (error) {
            toast.error(error?.response?.data?.error_message || error?.message);
            throw error;
        }
    }
}

export default UserAPIs;
